/**
 * One of the four nav buttons: a 36 px borderless square that fills with `well`
 * on hover (R6.6 — M1a drew a `line2` ring around each of them, which read as
 * four more cards inside the rail).
 *
 * Moved here from `MoveList/`, unchanged except for the ring and the size.
 */
import React from 'react';
import {Pressable, StyleSheet} from 'react-native';

import Icon, {IconName} from '../../../components/Icon';
import {RADIUS} from '../../../theme/tokens';
import {useV2Theme} from '../../../theme/useV2Theme';

const DISABLED_OPACITY = 0.35;
const BUTTON = 36;
const ICON_SIZE = 16;

export type NavButtonProps = {
  icon: IconName;
  onPress: () => void;
  disabled: boolean;
};

export default React.memo(function NavButtonView({
  icon,
  onPress,
  disabled,
}: NavButtonProps) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <Pressable
      disabled={disabled}
      onPress={onPress}
      style={({hovered}: any) => [
        styles.navButton,
        {
          backgroundColor: hovered && !disabled ? tokens.well : 'transparent',
          opacity: disabled ? DISABLED_OPACITY : 1,
        },
      ]}>
      <Icon name={icon} size={ICON_SIZE} color={tokens.ink2} />
    </Pressable>
  );
});

const styles = StyleSheet.create({
  navButton: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    height: BUTTON,
    borderRadius: RADIUS.control,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
